import ApiHook from './axiosAPI'

const { apiGET, apiPOST } = ApiHook()

const EmpresaAPI = {
  BuscarEmpresasCidade: async idcidade => {
    const url = `/public/buscarEmpresasCompletasAtivasPorCidade/?idcidade=${idcidade}`
    const req = await apiGET(url, true)
    return req
  },
  BuscarCidade: async cidade => {
    const url = `/public/filtrarCidadesAtivasPorNome/?nome=${cidade}`
    const req = await apiGET(url, true)

    return req
  },
  BuscarEmpresaUsername: async username => {
    const url = `/public/buscarPorUserName/?username=${username}`
    const req = await apiGET(url, true)

    return req
  },
  VerificaAcessoEmpresa: async (idempresa, idusuario) => {
    const url = `/empresas/buscarClientesPorFiltro/?isGestor=${false}`
    const req = await apiPOST(url, { idempresa: idempresa, idusuario: idusuario })

    return req
  },
  BuscarQuadrasEmpresa: async idempresa => {
    const url = `/public/buscarQuadrasPorEmpresa/?id=${idempresa}`
    const req = await apiGET(url, true)

    return req
  },
  BuscarAvaliacoesEmpresa: async (idempresa, offset, limit) => {
    const url = `/public/buscarPorEmpresa/?id=${idempresa}&limit=${limit}&offset=${offset}&countAll=${true}`
    const req = await apiGET(url, true)

    return req
  },
  SimularMensalista: async (idquadra, horarios, tipoMensalista, diaSemana) => {
    const buffer = {
      quadra_idquadra: idquadra,
      primeiroAgendamento: {
        dataInicio: horarios[0].dataInicio,
        dataFinal: horarios[horarios.length - 1].dataFinal,
      },
      tipoMensalista,
      diaSemana,
    }

    const url = '/mensalista/simular/'
    const req = await apiPOST(url, buffer)

    if (req.retorno) {
      return req
    } else {
      return { error: true, message: req.message }
    }
  },
  CriarMensalista: async blocoMensalista => {
    const url = '/mensalista/criarPorUsuario/'
    const req = await apiPOST(url, blocoMensalista)

    if (req.retorno) {
      return req
    } else {
      return { error: true, message: req.message }
    }
  },
  BuscarGradeHorarios: async (idquadra, date, idusuario) => {
    const url = `/public/horarios/?quadra_idquadra=${idquadra}&data=${date}&idusuario=${idusuario}`

    const req = await apiGET(url, true)
    //console.log('Grade horarios', req)
    return req
  },
  BuscarDiariasEmpresa: async (idempresa, diaSemana) => {
    const data = {
      idempresa: idempresa,
      diaSemana: diaSemana,
    }
    const url = '/public/buscarDayUseComprar/'
    const req = await apiPOST(url, data, true)

    return req
  },
  BuscarDiariasVendidas: async (idempresa, dataInicial, dataFinal) => {
    const url = `/public/filtrarDiariasVendidasPorEmpresa/?idempresa=${idempresa}&dataInicial=${dataInicial}&dataFinal=${dataFinal}`
    const req = await apiGET(url, true)
    if (req.error) return req //console.error('Erro ao buscar diárias vendidas')
    if (req.length) return req
  },
  SolicitarDiaria: async diaria => {
    /*
      body: JSON.stringify({
        "criadoPorGestor": 0,
        "criadoPor": await AsyncStorage.getItem("nomeUser"),
        "dayuse_iddayuse": this.state.dayuseSelected.iddayuse,
        "usuario_idusuario": await AsyncStorage.getItem("idUser"),
        "data": moment(this.state.dataCalendario),
        "formaPagamento": this.state.formaPagamento,
        "valorRealizado": this.state.formaPagamento === 'LOCAL' ? 0 : this.state.dayuseSelected.valor,
        "valorTotal": this.state.dayuseSelected.valor,
        "transacao": this.state.formaPagamento === 'CARTAO_CREDITO' ?
            {
                "tipo": "CARTAO_CREDITO",
                "payment_method_id": this.state.cartaoSelecionado.payment_method_id,
                "card_token": this.state.cartaoSelecionado.card_token,
            }
            : this.state.formaPagamento === 'PIX' ?
                { "tipo": "PIX" }
                : null
      })
    */

    const url = `/dayuse/aderirDayUse/?isGestor=${false}`
    const req = await apiPOST(url, diaria)
    return req
  },
  SolicitarAcessoCentroEsportivo: async (idempresa, idusuario, motivo) => {
    const url = `/empresas/solicitarIngresso/?isGestor=${false}`
    const data = {
      empresa_idempresa: idempresa,
      usuario_idusuario: idusuario,
      mensagemCliente: motivo,
    }
    const req = await apiPOST(url, data)

    if (!req.retorno) {
      return req
    } else {
      return { error: true, message: req.message }
    }
  },
  BuscarCuponsAtivosEmpresa: async idempresa => {
    const data = {
      idempresa: idempresa,
    }
    const url = '/cupom/buscarCuponsAtivosDaEmpresa'
    const req = await apiPOST(url, data)

    return req
  },
  SolicitarPedidoNovaGrade: async buffer => {
    const url = '/pedidos/criarNovaEstrutura/'
    const req = await apiPOST(url, buffer)
    return req
  },
  SolicitarReagendamento: async data => {
    const url = '/pedidos/reagendarPedido'
    const req = await apiPOST(url, data)
    return req
  },
  BuscarPrecoFixoId: async id => {
    const url = `/quadras/buscaPrecoFixoId/${id}`
    const req = await apiGET(url)
    return req
  },
}

export default EmpresaAPI
